/**
 * Authentication Helper Plugin
 */

export function isAuthenticated() {
    let jwt = localStorage.getItem('nutricrm_token')
    return (jwt !== null)
}

export function getToken() {
    let jwt = localStorage.getItem('nutricrm_token')
    return jwt
}

export function setToken(token) {
    localStorage.setItem('nutricrm_token', token)
}

export function clearAuthentication() {
    localStorage.removeItem('nutricrm_token')
}